import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CtaPopup } from '../../../infra/ui/cta-popup';
import styles from './styles.module.scss';
import { Link } from '../../../infra/routing';
import Icon, { GLYPHS } from '../../../../app/common/icon';
import Pill from '../../../../app/common/Pill';
import { t } from '../../../infra/i18n';
export var ClientReferralsCtaPopup = function (_a) {
    var onClose = _a.onClose;
    return (_jsx(CtaPopup, { id: "client-referrals", showCloseButton: true, onClose: onClose, children: _jsxs("div", { className: styles.container, children: [_jsx("div", { className: styles.pill, children: _jsx(Pill, { children: t('common:beta_label') }) }), _jsx("div", { className: styles.heading, children: t('common:cta_popup.heading') }), _jsxs(Link, { className: styles.link, to: "/client-referrals", onClick: onClose, children: [t('common:cta_popup.setup_button'), _jsx(Icon, { glyph: GLYPHS.chevronLeftBold })] }), _jsx("div", { className: styles.image })] }) }));
};
